import ReactBasicsImage from '../images/ReactBasics.png'
import AdvancedReact from '../images/AdvancedReact.png'
import LittleLemon from '../images/LittleLemon.png'
import CryptoTweet from '../images/CryptoTweet.png'
import Ecommerce from '../images/Ecommerce.png'
import FrontEndCertificate from '../images/FrontEndCertificate.png'
import Django from '../images/Django.png'
import DjangoJobPortal from '../images/DjangoJobPortal.png'
import NotionAIImage from '../images/NotionAI.png'

export const Bio = {
  name: "Vinay Jagannavar",
  roles: [
    "Full Stack Developer",
    "Backend Developer",
    "Frontend Developer",
    "Data Scientist"
  ],
  description:
    "I bring ideas to life with code.  I'm a passionate software developer who thrives on tackling challenges and creating clean, efficient solutions. My love for learning fuels my expertise in new technologies, and I'm constantly seeking ways to craft amazing things. Let's collaborate and build something truly remarkable!",
  github: "https://github.com/vinayjagannavar",
  resume:
    "https://drive.google.com/file/d/1ur3fuzWvHjk6q3e5C9ZLmEw35gtNt0dw/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/vinay-jagannavar-6a0217124",
  insta: "https://www.instagram.com/vinay_jagannavar/",
  phone: "+13156037616",
  leetcode: "https://leetcode.com/vinay_jagannavar"
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "ReactJs",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Angular",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg",
      },
      {
        name: "HTML5",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://cdn.icon-icons.com/icons2/2107/PNG/512/file_type_tailwind_icon_130128.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.2/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      {
        name: "Figma",
        image:
          "https://www.liblogo.com/img-logo/fi441f906-figma-logo-figma-logo-png-transparent-amp-svg-vector-freebie-supply.png",
      }
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Django",
        image:
          "https://banner2.cleanpng.com/20180711/rtc/kisspng-django-web-development-web-framework-python-softwa-django-5b45d913f29027.4888902515313042119936.jpg",
      },
      {
        name: "Flask",
        image: "https://assets-global.website-files.com/63894f0e251e567f6e443bfa/64a25628612c9db05d4c7f56_63c10c7b6f20f424c72490bf_flask.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Spring Boot",
        image:"https://dz2cdn1.dzone.com/storage/temp/12434118-spring-boot-logo.png",
      },
      {
        name: "Spring Security",
        image:"https://img.stackshare.io/service/6656/com.castsoftware.springsecurity.png",
      },
      {
        name: ".NET",
        image:"https://www.vhv.rs/dpng/d/610-6101227_-net-core-logo-png-transparent-png.png",
      },
      {
        name: "PyTorch",
        image:"https://pytorch.org/assets/images/pytorch-logo.png",
      },
      {
        name: "TensorFlow",
        image:"https://i1.wp.com/albertfattal.com/wp-content/uploads/2018/03/Tensorflow_logo.svg.png?resize=1200%2C1283&ssl=1",
      },
      {
        name: "C",
        image: "https://th.bing.com/th/id/OIP.-wK8kSbegCP7kdE8hVjRCQAAAA?rs=1&pid=ImgDetMain",
      },
      {
        name: "C++",
        image: "https://th.bing.com/th/id/OIP.gjzpE3MhNBoZx3LrHA5-9wHaER?rs=1&pid=ImgDetMain",
      },
      {
        name: "C#",
        image: "https://e7.pngegg.com/pngimages/520/669/png-clipart-c-logo-c-programming-language-computer-icons-computer-programming-programming-miscellaneous-blue.png",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      }
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      }
    ],
  },
  {
    title: "Cloud",
    skills: [
      {
        name: "Amazon Web Services",
        image:"data:image/png;base64,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",
      },
      {
        name: "Microsoft Azure DevOps Services",
        image:
          "https://seeklogo.com/images/A/azure-devops-logo-E7364216A7-seeklogo.com.png",
      },
      {
        name: "Docker",
        image:
          "https://iconape.com/wp-content/files/cr/55190/png/docker.png",
      },
      {
        name: "Kubernetes",
        image:"https://th.bing.com/th/id/R.ea798a7abf761b1b7b965a9f16eee1a6?rik=aC4g1T9IpqNckw&riu=http%3a%2f%2fassets.stickpng.com%2fimages%2f58480a44cef1014c0b5e4917.png&ehk=KPnoo5nTF29FI5rf23YFWnTfRzUkinLBnE6D0A8u730%3d&risl=&pid=ImgRaw&r=0",
      }
    ]
  },
  {
    title: "Databases",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "NoSQL",
        image:
          "https://th.bing.com/th/id/R.49ba9d9a8aea508fbb1a224177049182?rik=6%2bwdPMdfCzZgaA&riu=http%3a%2f%2fwww.kingswaysoft.com%2fFrontend%2fImages%2fssis-component-icons%2fssis-productivity-pack-icons%2fnosql-icon.png&ehk=IxgZibjryFhUNOsPTyKS8IK%2fipsKFwrn69qEmeCDd2U%3d&risl=&pid=ImgRaw&r=0",
      }
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://th.bing.com/th/id/OIP.DPbpk1NuTZpPOUyILogxogHaHk?rs=1&pid=ImgDetMain",
      },
      {
        name: "GitHub",
        image:
          "https://pngimg.com/uploads/github/github_PNG67.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },{
        name: "Siebel CRM",
        image:
          "https://th.bing.com/th/id/OIP.BEJgnZK66Uv7x73R92bLRwHaDW?rs=1&pid=ImgDetMain",
      },     
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://www.svgrepo.com/show/354202/postman-icon.svg",
      },
      {
        name: "Splunk",
        image:
          "https://www.logolynx.com/images/logolynx/b4/b488ffd251ebf4fcdd8d2ab1be453989.png",
      },{
        name: "UiPath",
        image:
          "https://companieslogo.com/img/orig/PATH-4f96bcbf.png?t=1649160715",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://imageio.forbes.com/specials-images/imageserve/5d52cca168cb0a000916d49b/0x0.jpg?format=jpg&crop=416,416,x0,y0,safe&height=87&width=87",
    role: "Full-Stack Developer Intern",
    company: "Syracuse University - Engineering and Computer Science Department",
    date: "July 2024 - Present",
    desc: `I am currently focused on developing secure and scalable financial solutions using ReactJS, Node.js and Express.js, which optimize transaction workflows and data processing. I design RESTful services and microservices for seamless integration, while crafting responsive React interfaces with Redux and Bootstrap to enhance user experiences in online banking. Utilizing MongoDB and Mongoose, I efficiently manage high-volume databases and lead automated testing efforts with Jest. I also streamline development processes with npm and Webpack, and employ WebSocket and GraphQL for real-time communication, achieving a 30% reduction in response times for improved financial operations.`,
    skills: [
      "Next.js",
      "Node.js",
      "Express.js",
      "React",
      "JavaScript",
      "Redux",
      "WebHooks",
      "Bootstrap",
      "Mongoose",
      "MongoDB",
      "Jest",
      "React Testing Library",
      "npm",
      "Webpack",
      "Log4js",
      "WebSocket",
      "GraphQL",
      "REST"
    ],
    //doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 1,
    img: "https://download.logo.wine/logo/Tech_Mahindra/Tech_Mahindra-Logo.wine.png",
    role: "Full Stack Software Engineer",
    company: "Tech Mahindra Limited",
    date: "April 2018 - July 2022",
    desc: `I had the opportunity to work across all phases of the SDLC for healthcare applications, ensuring compliance with data privacy and security regulations while utilizing Agile and Scrum methodologies. I developed single-page applications (SPAs) for healthcare portals using Angular, TypeScript, and RxJS. I also led the development of microservices with Java and Spring, incorporating Spring MVC, Spring Boot, and Spring Cloud, and integrated Spring Data JPA with Hibernate 5.x for efficient data management. Additionally, I launched scalable, cloud-based solutions on AWS (EC2, VPC, RDS, S3) and implemented Test-Driven Development (TDD) using Selenium and Mockito. My experience included streamlining build and deployment processes with Maven, Jenkins, and Docker.`,
  skills: [
  "Java",
  "Angular",
  "Spring Boot",
  "Spring MVC",
  "Spring Cloud",
  "Spring Data JPA",
  "Hibernate",
  "TypeScript",
  "Amazon Web Service",
  "Selenium",
  "Mockito",
  "Jasmine",
  "Maven",
  "Jenkins",
  "Docker",
  "Postman",
  "RESTful API",
  "RxJS"
  ],
    //doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 2,
    img: "https://mma.prnewswire.com/media/690233/Mphasis_Logo.jpg?p=twitter",
    role: "Java Developer",
    company: "Mphasis",
    date: "April 2017 - March 2018",
    desc: `I developed responsive web applications for insurance services using React, HTML, CSS, JavaScript, JSP, and Bootstrap, focusing on user experience and optimized load times. I architected Spring MVC applications that featured robust transaction management and validation while utilizing Java SE 8 and multithreading for enhanced backend performance in high-volume claims processing. I improved database efficiency with JPA, Hibernate, and XML Schema configurations and designed scalable systems on AWS (EC2, S3, RDS, Lambda). Additionally, I led cross-functional teams to implement CI/CD pipelines with Jenkins and Git, automating testing and deployment processes for greater delivery efficiency.
    `,
    skills: [
      "Java",
      "JavaScript",
      "React",
      "Spring MVC",
      "Hibernate",
      "HTML",
      "CSS",
      "JSP",
      "Bootstrap",
      "JPA",
      "XML",
      "Amazon Web Services",
      "Jenkins CI/CD",
      "Git"
    ],
  },
  {
    id: 3,
    img: "https://images.jdmagicbox.com/comp/pune/y9/020pxx20.xx20.170601200228.m4y9/catalogue/krixi-ideas-and-technology-solutions-pvt-ltd-hingne-khurd-pune-software-companies-nyhw0opji0.jpg",
    role: "Software Developer Intern",
    company: "Krixi Ideas and Technology Solutions Pvt Ltd",
    date: "April 2017 - March 2018",
    desc: `• Developed a Java-based Android app, featuring scheduling medical appointments, notification reminders, Google Fit for fitness tracking, OAuth 2.0 authentication, and MP Chart for data visualization.<br />
    •	Orchestrated backend operations with Node.js and Express for RESTful APIs, centralized databases for appointments and prescriptions, and leveraged Gradle for build automation with Jenkins for CI, ensuring scalability and reliability.
    `,
    skills: [
      "Java",
      "Kotlin",
      "Object Oriented Programming",
      "Android Studio",
      "REST API",
      "XML",
    ],
  }
];

export const education = [
  {
    id: 0,
    img: "https://imageio.forbes.com/specials-images/imageserve/5d52cca168cb0a000916d49b/0x0.jpg?format=jpg&crop=416,416,x0,y0,safe&height=87&width=87",
    school: "Syracuse University, NY, US",
    date: "August 2022 - May 2024",
    grade: "3.8 GPA",
    desc: "Courses: Design and Analysis of Algorithms, Structured Programming and Formal Methods, Operating System, Computer Architecture, Artificial Intelligence, Machine Learning, Natural Language Processing, Android Programming, Social Media and Data Mining.",
    degree: "Masters Of Science - Computer Science",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5C74v3rfUB0RbnoE2fR2leNmsmhlHQF2ZqyWXcX7A9w&s",
    school: "University Of Pune, India",
    date: "July 2013 - May 2017",
    grade: "3.4 GPA",
    desc: "Courses: Data Structures and Algorithms, Object Oriented Design, Database Management Systems, Theory Of Computations.",
    degree: "Bachelors of Engineering - Computer Engineering",
  }
];

export const projects = [
  {
    id: 3,
    title: "AI-Powered Notion Clone",
    date: "Mar 2025",
    description:
      `• Built with React (Next.js) and TypeScript for a performant frontend.
      • Integrated Clerk for authentication and Firebase for real-time data storage.
      • Enabled real-time collaboration using Liveblocks.
      • Used Cloudflare Workers to manage backend logic via serverless architecture.
      • Designed modern, responsive UI with Shadcn/UI.
      • Embedded OpenAI GPT API for smart document features like content generation, summarization, and contextual Q&A.`,
    image: NotionAIImage,
    tags: [
      "ReactJS",
      "NextJS",
      "JavaScript(ES6+)",
      "Hono",
      "Cloudflare Worker",
      "LiveBlocks",
      "Shadcn",
      "OpenAI API",
      "Vercel",
      "Tailwind CSS"
    ],
    category: "web app",
    github: "https://github.com/vinayjagannavar/Notion-clone-AI-frontend",
    webapp: "https://github.com/vinayjagannavar/notion-clone-cloudflare-backend",
  },
  {
    id: 0,
    title: "Ecommerce Shopping",
    date: "January 2024 - March 2024",
    description:
      `•	Pioneered RESTful API implementation with Spring Boot for seamless frontend-backend communication, while enforcing Spring Security and employing MySQL for efficient backend management.
      •	Orchestrated frontend development leveraging React, integrating Tailwind CSS and Material-UI (MUI) for UI design, Redux for state management, and JWT for secure authentication.
      `,
    image: Ecommerce,
    tags: [
      "React JS",
      "Redux",
      "Java",
      "JSON Web Tokens",
      "Spring Boot",
      "Spring Security",
      "Tailwind CSS",
      "Material-UI",
      "MySQL"
    ],
    category: "web app",
    github: "https://github.com/vinayjagannavar/Ecommerce-Shopping-Backend",
    webapp: "https://clothcrafters.vercel.app/",
  },
  {
    id: 6,
    title: "Job Portal",
    date: "April 2024 - May 2024",
    description:
      `• Led the creation of extensive frontend and backend components leveraging Python within the resilient Django Web Framework, following the Model-View-Template (MVT) architectural paradigm to ensure organized application design and upkeep.
      •	Managed the deployment of the application on AWS via EC2 for hosting, employing RDS coupled with Postgres for efficient database administration, and S3 for the storage of static and media files.
      •	Integrated dynamic content seamlessly using Django Template Language, Bootstrap, and HTML, crafting a responsive and visually captivating user interface to elevate user engagement.
      `,
    image: DjangoJobPortal,
    tags: [
      "Python",
      "Django",
      "AWS EC2",
      "AWS RDS",
      "AWS S3",
      "Bootstrap",
      "HTML5"
    ],
    category: "web app",
    github: "https://github.com/vinayjagannavar/Job-Portal-Django.git",
    webapp: "http://3.137.203.198:8000/",
  },
  {
    id: 1,
    title: "BillBuddy",
    date: "September 2023 - December 2023",
    description:
      `• Architected and developed a responsive Kotlin Android app utilizing OOPs and LiveData (20% reduced data latency). Implemented engaging bill-splitting & spending analysis features (coroutines) leading to a 15% user engagement rise.
      • Facilitated secure payment processing via PayPal integration, championed the use of GitHub for version control (reducing merge conflicts by 30%), fostering a collaborative development workflow.
      `,
    image:
      "https://raw.githubusercontent.com/vinayjagannavar/BillBuddy/main/Screenshot%202024-03-31%20234421.png",
    tags: ["Kotlin", "MVVM", "Room Database", "AWS Gateway API", "AWS RDS"],
    category: "android app",
    github: "https://github.com/vinayjagannavar/BillBuddy",
    webapp: "https://github.com/vinayjagannavar/BillBuddy",
  },
  {
    id: 7,
    title: "Little Lemon Website",
    date: "Mar 2024",
    description:
      `• Developed the 'Reserve a Table' feature for the Little Lemon Website using React, effectively managing state with hooks such as useState. 
      • Implemented advanced form handling methods, including controlled and uncontrolled components, alongside the useRef hook, to optimize the booking process.
      • Performed thorough unit testing with Jest, guaranteeing the functionality and dependability of components.`,
    image: LittleLemon,
    tags: [
      "React JS",
      "JavaScript(ES6+)",
      "HTML5",
      "CSS",
      "Jest",
      "Git",
      "Figma",
      "API"
    ],
    category: "web app",
    github: "https://github.com/vinayjagannavar/LittleLemon",
    webapp: "https://github.com/vinayjagannavar/LittleLemon",
  },
  {
    id: 4,
    title: "Crypto Tweet Sentiment Analysis",
    date: "March 2023 - April 2023",
    description:
      "Extracted actionable cryptocurrency market insights through large-scale NLP analysis (preprocessing, tokenization) of over 100k tweets, incorporating BERT models (FinBERT & CryptoBERT) for accurate sentiment classification.",
    image: CryptoTweet,
    tags: ["Python", "NLP", "Pandas", "Numpy", "TensorFlow", "Keras","Seaborn"],
    category: "machine learning",
    github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    webapp: "https://brain-tumor.netlify.app/",
  },
  {
    id: 2,
    title: "AI-based 2048 Game",
    date: "September 2022 - December 2022",
    description:
      `• Executed Expectimax algorithm for tree search AI in 2048 game, considering chance and limited depth search; algorithm optimized move selection, resulting in a 25% increase in game win rate.
      • Upgraded tree search with a neural network trained on game state data and projected utility values for each level.
      `,
    image:
      "https://raw.githubusercontent.com/vinayjagannavar/2048-Expectimax-AI-Game/main/AIscores.png",
    tags: ["Python", "PyTorch", "MatplotLib", "NumPy", "AI Algorithm"],
    category: "machine learning",
    github: "https://github.com/vinayjagannavar/2048-Expectimax-AI-Game",
    webapp: "https://github.com/vinayjagannavar/2048-Expectimax-AI-Game",
  },
  {
    id: 5,
    title: "Stock Price Prediction using GAN and ARIMA",
    date: "February 2024 - March 2024",
    description:
      `• This project analyzes the impact of Twitter sentiments on Google's stock prices using Afinn and Vader for sentiment analysis and integrates predictive modeling techniques, GANs and ARIMA, with Yahoo Finance data to forecast stock trends. The analysis provides insights into how public perceptions influence financial markets, serving as a bridge between social media sentiment and economic indicators.
      `,
    image:
      "https://raw.githubusercontent.com/vinayjagannavar/Stock-Price-Prediction-GAN-ARIMA/main/GANvsARIMA.png",
    tags: ["Python", "TensorFlow", "Pandas", "Numpy", "MatplotLib", "Seaborn"],
    category: "machine learning",
    github: "https://github.com/vinayjagannavar/Stock-Price-Prediction-GAN-ARIMA",
    webapp: "https://github.com/vinayjagannavar/Stock-Price-Prediction-GAN-ARIMA",
  },
];

export const certifications = [
  {
    id: "1",
    name: "Meta Front-End Developer Professional Certificate",
    image: FrontEndCertificate,
    description: "- Coursera",
    certificateURL: "https://www.coursera.org/account/accomplishments/professional-cert/ANAK6V7KVQS8"
  },
  {
    id: "1",
    name: "React Basic",
    image: ReactBasicsImage,
    description: "- Coursera",
    certificateURL: "https://www.coursera.org/account/accomplishments/verify/8CLUGAP33QTF"
  },
  {
    id: "2",
    name: "Advanced React",
    image: AdvancedReact,
    description: "- Coursera",
    certificateURL: "https://www.coursera.org/account/accomplishments/verify/T63G2N5BHWDZ"
  },
  {
    id: "3",
    name: "Django Web Framework",
    image: Django,
    description: "- Coursera",
    certificateURL: "https://coursera.org/share/586b32cac632cbda7f286d5ebded0a65"
  },
  // Add more certifications as needed
];
